<template>
    <transition name="fade">
        <div
            class="fixed inset-0 flex items-start justify-center p-4 overflow-y-auto"
            v-if="show"
        >
            <div
                class="fixed inset-0 z-10 bg-black opacity-50"
                @click="closeForm()"
            ></div>
            <div
                class="relative z-20 w-full max-w-6xl bg-white rounded-lg shadow-lg"
            >
                <div class="px-0 py-4 md:px-4 md:py-8">
                    <form @submit.prevent="submit()">
                        <div class="flex flex-col w-full md:flex-row">
                            <div class="w-full px-4 md:w-1/2">
                                <div
                                    class="flex justify-between p-4 mb-4 bg-gray-100 border border-gray-200 rounded"
                                >
                                    <div>
                                        <div class="font-bold">
                                            {{ selectedHouse.address }}
                                        </div>
                                        <div>
                                            {{ selectedHouse.phone }}
                                        </div>
                                        <div>
                                            {{ selectedHouse.email }}
                                        </div>
                                    </div>
                                    <div class="text-right">
                                        <div>
                                            {{
                                                moment(selectedDate)
                                                    .locale('cs')
                                                    .format('dddd')
                                            }}<br />
                                        </div>
                                        <div class="font-bold">
                                            {{
                                                moment(selectedDate).format(
                                                    'D. M. YYYY'
                                                )
                                            }}
                                        </div>
                                        <div>
                                            {{
                                                moment(
                                                    selectedTime,
                                                    'HH:mm:ss'
                                                ).format('H:mm')
                                            }}
                                            {{
                                                this.timeTo
                                                    ? `- ${this.timeTo}`
                                                    : ''
                                            }}
                                        </div>
                                    </div>
                                </div>

                                <label class="block w-full mb-4">
                                    <div class="mb-1 text-sm text-black">
                                        Vyberte typ vyšetření
                                    </div>
                                    <div class="select">
                                        <select
                                            v-model="formData.examination_id"
                                            class="input"
                                        >
                                            <option value="0" selected disabled
                                                >Vybrat vyšetření</option
                                            >
                                            <option
                                                v-for="examination in selectedHouse.examinations"
                                                :key="examination.id"
                                                :value="examination.id"
                                                :disabled="
                                                    isDisabled(examination)
                                                "
                                            >
                                                {{ examination.name }}
                                                ({{
                                                    getDuration(
                                                        examination.duration
                                                    )
                                                }}
                                                minut)
                                            </option>
                                        </select>
                                        <div
                                            class="text-xs text-red-500"
                                            v-if="errors.examination_id"
                                        >
                                            {{ errors.examination_id[0] }}
                                        </div>
                                    </div>
                                </label>

                                <div v-if="formData.examination_id">
                                    <div
                                        class="flex justify-between mb-4 overflow-auto rounded"
                                    >
                                        <div class="text-base text-black">
                                            <div
                                                v-if="
                                                    formData.examination_id ===
                                                        1
                                                "
                                            >
                                                Na vyšetření zraku přijďte v
                                                ideálním případě odpočatí. Únava
                                                může zkreslit výsledky
                                                měření.<br /><br />
                                                Pokud jste u nás ještě na
                                                vyšetření nebyli, vezměte si s
                                                sebou co nejvíce údajů o Vašich
                                                brýlích a zdravotním stavu
                                                (anamnézy, nálezy, vyšetření).
                                                Pokud už brýle používáte,
                                                přineste všechny, které aktuálně
                                                nosíte (dálka, počítač, čtení).
                                                Zamyslete se nad rozložením Vaší
                                                pracovní plochy, vzdálenost
                                                monitoru počítače, čtení. Tyto
                                                údaje upřesní měření.
                                                <br /><br />
                                                Nosíte-li kontaktní čočky,
                                                nemějte je v očích od rána, po
                                                probuzení si kontaktní čočky
                                                nenasazujte.
                                                <br /><br />
                                                Vyšetřujeme klienty od 15 let
                                                věku. Pokud máme vyšetřit dítě
                                                do 15 let, je potřeba donést
                                                doporučení lékaře, že můžeme
                                                vyšetření provést. Vaše osobní
                                                údaje slouží pouze pro potřeby
                                                naší oční optiky.
                                                <br /><br />
                                                <strong
                                                    >Vyšetření je 300,- Kč. Při
                                                    následném zhotovení brýlí,
                                                    spojeném s nákupem nové
                                                    brýlové obruby, v celkové
                                                    hodnotě zakázky nad 2.500,-
                                                    Kč je měření zdarma.</strong
                                                >
                                            </div>
                                            <div
                                                v-else-if="
                                                    formData.examination_id ===
                                                        2 || 4
                                                "
                                            >
                                                Na vstupní vyšetření kontaktních
                                                čoček přijďte v ideálním případě
                                                odpočatí. Únava může zkreslit
                                                výsledky měření.
                                                <br /><br />
                                                Pokud jste u nás ještě na
                                                vyšetření nebyli, vezměte si s
                                                sebou co nejvíce údajů o Vašich
                                                brýlích a zdravotním stavu
                                                (anamnézy, nálezy, vyšetření).
                                                Pokud jste už kontaktní čočky
                                                nosili, přineste s sebou typ
                                                kontaktních čoček, případně
                                                krabičku či blistr.
                                                <br /><br />
                                                Nosíte-li kontaktní čočky,
                                                nemějte je v očích od rána, po
                                                probuzení si kontaktní čočky
                                                nenasazujte. Průběh vstupního
                                                vyšetření: nebo napsat průběh
                                                vstupního vyšetření najdete v
                                                záložce kontaktní čočky.....
                                                <br /><br />
                                                <ul>
                                                    <li>
                                                        1. Vstupní pohovor
                                                        (anamnéza, motivace
                                                        klienta, seznámení s
                                                        kontaktními čočkami a
                                                        jejich správným
                                                        používáním)
                                                    </li>
                                                    <li>
                                                        2. Měření zraku a
                                                        parametrů rohovky
                                                        zkušeným optometristou
                                                        za pomoci
                                                        autorefrakto-keratometru,
                                                        polarizovaného LCD
                                                        optotypu a zkušební sady
                                                    </li>
                                                    <li>
                                                        3. Vyšetření předního
                                                        segmentu pomocí
                                                        štěrbinové lampy
                                                    </li>
                                                    <li>
                                                        4. Výběr optimální
                                                        kontaktní čočky s
                                                        přihlédnutím k naměřeným
                                                        parametrům,
                                                        předpokládané frekvenci
                                                        nošení, ceny
                                                    </li>
                                                    <li>
                                                        5. Aplikace zkušebního
                                                        páru čoček optometristou
                                                    </li>
                                                    <li>
                                                        6. Kontrola usazení,
                                                        předběžná kontrola
                                                        zrakové ostrosti
                                                    </li>
                                                    <li>
                                                        7. Toleranční test
                                                        (klient na hodinu
                                                        odchází s nasazenými
                                                        čočkami)
                                                    </li>
                                                    <li>
                                                        8. Kontrola zrakové
                                                        ostrosti, reakce oka,
                                                        usazení kontaktní čočky,
                                                        subjektivního pohodlí
                                                    </li>
                                                    <li>
                                                        9. Zácvik manipulace
                                                        (bezpečné nasazení,
                                                        vyjmutí)
                                                    </li>
                                                    <li>
                                                        10.Klient si odnáší
                                                        zkušební pár, případně
                                                        startovací balení
                                                        roztoku
                                                    </li>
                                                </ul>
                                                <br /><br />
                                                Na kontaktní čočky poskytujeme
                                                slevu, která se liší podle počtu
                                                u nás zakoupených prodejních
                                                balení. Cílem je motivovat
                                                klienta, aby nestřídal aplikační
                                                střediska, docházel pravidelně
                                                na kontroly a nosil pouze takové
                                                kontaktní čočky, které co možná
                                                nejlépe vyhovují jeho
                                                individuálním požadavkům a
                                                potřebám. Vyšetřujeme klienty od
                                                15 let věku. Pokud máme vyšetřit
                                                dítě do 15 let, je potřeba
                                                donést doporučení lékaře, že
                                                můžeme vyšetření provést. Vaše
                                                osobní údaje slouží pouze pro
                                                potřeby naší oční optiky.
                                                <br /><br />
                                                <strong
                                                    >Cena vstupního vyšetření
                                                    pro klienta, který neumí s
                                                    kontaktní čočkou
                                                    manipulovat, je 900,- Kč.
                                                    Sleva pro studenty
                                                    10%.</strong
                                                ><br /><br />
                                                <strong
                                                    >Cena vstupního vyšetření
                                                    pro zkušeného nositele
                                                    kontaktních čoček je 500,-
                                                    Kč.</strong
                                                >
                                            </div>
                                            <div
                                                v-else-if="
                                                    formData.examination_id ===
                                                        3
                                                "
                                            >
                                                Na kontrolu kontaktních čoček
                                                přijďte v nasazených čočkách.
                                                Nasazené byste je měli mít
                                                alespoň dvě hodiny před
                                                kontrolou. Za kontrolu klienti
                                                našeho aplikačního střediska,
                                                kteří si u nás i pravidelně
                                                kupují kontaktní čočky, nic
                                                neplatí. <br /><br />
                                                <strong
                                                    >Pokud chce provést kontrolu
                                                    klient, který od nás
                                                    pravidelně nenakupuje
                                                    kontaktní čočky, kontrola
                                                    stojí 500,- Kč.
                                                </strong>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div
                                    class="flex justify-between p-4 mb-4 bg-blue-100 border border-blue-200 rounded"
                                >
                                    <div class="text-xs font-bold text-red-500">
                                        Po vytvoření rezervace Vám dáme vědět,
                                        že byla rezervace potvrzena.
                                    </div>
                                </div>
                            </div>

                            <div class="w-full px-4 md:w-1/2">
                                <div class="sticky top-0 pt-8 -mt-8">
                                    <div class="flex flex-wrap -mx-2">
                                        <div class="w-full px-2 md:w-1/2">
                                            <label class="block w-full mb-4">
                                                <div
                                                    class="mb-1 text-sm text-black"
                                                >
                                                    jméno
                                                </div>
                                                <input
                                                    type="text"
                                                    v-model="
                                                        formData.first_name
                                                    "
                                                    name="first_name"
                                                    class="input"
                                                />
                                                <div
                                                    class="text-xs text-red-500"
                                                    v-if="errors.first_name"
                                                >
                                                    {{ errors.first_name[0] }}
                                                </div>
                                            </label>
                                        </div>
                                        <div class="w-full px-2 md:w-1/2">
                                            <label class="block w-full mb-4">
                                                <div
                                                    class="mb-1 text-sm text-black"
                                                >
                                                    příjmení
                                                </div>
                                                <input
                                                    type="text"
                                                    v-model="formData.last_name"
                                                    name="last_name"
                                                    class="input"
                                                />
                                                <div
                                                    class="text-xs text-red-500"
                                                    v-if="errors.last_name"
                                                >
                                                    {{ errors.last_name[0] }}
                                                </div>
                                            </label>
                                        </div>
                                    </div>
                                    <label class="block w-full mb-4">
                                        <div class="mb-1 text-sm text-black">
                                            e-mail
                                        </div>
                                        <input
                                            type="text"
                                            v-model="formData.email"
                                            name="email"
                                            class="input"
                                        />
                                        <div
                                            class="text-xs text-red-500"
                                            v-if="errors.email"
                                        >
                                            {{ errors.email[0] }}
                                        </div>
                                    </label>
                                    <label class="block w-full mb-4">
                                        <div class="mb-1 text-sm text-black">
                                            telefon
                                        </div>
                                        <input
                                            type="text"
                                            v-model="formData.phone"
                                            name="phone"
                                            class="input"
                                        />
                                        <div
                                            class="text-xs text-red-500"
                                            v-if="errors.phone"
                                        >
                                            {{ errors.phone[0] }}
                                        </div>
                                    </label>
                                    <label class="block w-full mb-4">
                                        <div class="mb-1 text-sm text-black">
                                            poznámka
                                        </div>
                                        <textarea
                                            rows="5"
                                            v-model="formData.note"
                                            name="note"
                                            class="input"
                                        ></textarea>
                                        <div
                                            class="text-xs text-red-500"
                                            v-if="errors.note"
                                        >
                                            {{ errors.note[0] }}
                                        </div>
                                    </label>
                                    <label
                                        class="flex items-baseline block w-full mb-4"
                                    >
                                        <input
                                            type="checkbox"
                                            v-model="formData.terms"
                                            name="terms"
                                            class="mr-1 checkbox"
                                        />
                                        <a
                                            class="mb-1 text-sm text-black hover:underline"
                                            target="_blank"
                                            href="http://www.ocnioptikaolomouc.cz/gdpr/"
                                        >
                                            Souhlasím se zpracováním osobních
                                            dat
                                        </a>
                                        <div
                                            class="text-xs text-red-500"
                                            v-if="errors.terms"
                                        >
                                            {{ errors.terms[0] }}
                                        </div>
                                    </label>
                                    <div class="flex justify-between">
                                        <button
                                            type="button"
                                            @click="closeForm()"
                                            class="px-4 py-2 text-white transition bg-gray-400 border-b-2 border-gray-500 rounded hover:bg-gray-500 hover:border-gray-600"
                                        >
                                            Vybrat jiný termín
                                        </button>
                                        <button
                                            type="submit"
                                            class="px-4 py-2 text-white transition border-b-2 rounded bg-primary-200 border-primary-400 hover:bg-primary-500 hover:border-primary-600"
                                        >
                                            <template v-if="loading">
                                                Odesílám...
                                            </template>
                                            <template v-else>
                                                Odeslat
                                            </template>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import moment from 'moment'
import axios from 'axios'

export default {
    props: [
        'show',
        'selectedDate',
        'selectedTime',
        'selectedHouse',
        'avaliableDuration'
    ],
    data() {
        return {
            loading: false,
            errors: [],
            formData: {
                examination_id: 0,
                employee_id: 0,
                first_name: '',
                last_name: '',
                email: '',
                phone: '',
                note: '',
                terms: ''
            }
        }
    },
    computed: {
        employees() {
            if (!this.formData.examination_id) {
                return []
            }
            return this.selectedHouse.examinations.find(x => {
                return x.id === this.formData.examination_id
            }).employees
        },
        timeTo() {
            if (!this.formData.examination_id) {
                return null
            }
            let duration = this.selectedHouse.examinations.find(x => {
                return x.id === this.formData.examination_id
            }).duration
            return moment(this.selectedTime, 'HH:mm:ss')
                .add(moment.duration(duration).asMinutes(), 'minutes')
                .format('H:mm')
        }
    },
    methods: {
        moment,
        closeForm() {
            this.formData.examination_id = 0
            this.$emit('close')
        },
        getDuration(duration) {
            return moment.duration(duration).asMinutes()
        },
        isDisabled(examination) {
            let ed = moment.duration(examination.duration).asMinutes()
            let ad = moment.duration(this.avaliableDuration).asMinutes()
            return ad < ed
        },
        submit() {
            this.loading = true
            axios
                .post(`${process.env.VUE_APP_API_URL}/reservations`, {
                    ...this.formData,
                    ...{
                        from: `${this.moment(this.selectedDate).format(
                            'YYYY-MM-DD'
                        )} ${this.selectedTime}`,
                        house_id: this.selectedHouse.id
                    }
                })
                .then(() => {
                    this.loading = false
                    this.$notify({
                        type: 'success',
                        title: 'Rezervace uložena',
                        text: 'Budeme se těšit'
                    })
                    this.$emit('refetch-timeline')
                    this.$emit('close')
                })
                .catch(e => {
                    this.loading = false
                    this.errors = e.response.data.errors
                    this.$notify({
                        type: 'error',
                        title: this.errors.global[0],
                        text: 'Zkontrolujte zda máte vyplněna všchna pole'
                    })
                })
        }
    }
}
</script>
